import React, { useEffect, useState } from 'react';
import { ViewProps, Dimensions } from 'react-native';
import Animated, {
  runOnJS,
  useAnimatedStyle,
  useDerivedValue,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated';
import { Platform } from 'src/libs/platform';
import { IOS_EASING, ANDROID_EASING } from 'src/themes/constants';

export type SlideInOutProps = ViewProps & {
  visible: boolean;
  onEnd?: () => void;
};

const SCREEN_HEIGHT = Dimensions.get('screen').height;
const DURATION = Platform.OS === 'ios' ? 400 : 320;
const EASING = Platform.OS === 'ios' ? IOS_EASING : ANDROID_EASING;

export const SlideInOut: React.FC<SlideInOutProps> = ({
  children,
  visible,
  onEnd,
  style,
  ...props
}) => {
  const [shouldRender, toggle] = useState(false);
  const sv = useSharedValue(1);
  const dv = useDerivedValue(() => sv.value * SCREEN_HEIGHT);

  const transition = useAnimatedStyle(() => ({
    transform: [{ translateY: dv.value }],
  }));

  const onAnimationEnd = () => {
    if (onEnd) onEnd();
  };

  useEffect(() => {
    if (visible && !shouldRender) {
      toggle(true);
      sv.value = withTiming(0, {
        duration: DURATION,
        easing: EASING,
      });
    }

    if (!visible && shouldRender) {
      sv.value = withTiming(1, { duration: DURATION, easing: EASING }, () =>
        runOnJS(onAnimationEnd)()
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible, shouldRender]);

  return !shouldRender ? null : (
    <Animated.View style={[style, transition]} {...props}>
      {children}
    </Animated.View>
  );
};
